import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import { loadCareGuidePartnerTagsAdmin } from '../../../../../state/modules/careGuidePartnerTagsAdmin/actions';
import CareGuidePartnerTagInput from '../components/CareGuidePartnerTagInput';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const defaultLimit = 10;
const defaultOrder = 'id.asc';

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  // merge results for all modules
  const results = [].concat.apply(
    [],
    Object.entries(
      state.careGuidePartnerTagsAdmin.getIn(
        ['pages', defaultOrder, defaultLimit],
        {}
      )
    ).map(([k, v]) => v.toArray())
  );

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['careGuidePartnerTagsAdmin', x]),
              schema.careGuidePartnerTagAdmin,
              state.entities.toJS()
            ),
          };
        })
      : [];
  return {
    options: list,
    isLoading: state.careGuidePartnerTagsAdmin.get('isLoading'),
    partnershipId,
    defaultLimit,
    defaultOrder,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      partnershipId,
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      filter = {},
      cb = function () {}
    ) => {
      dispatch(
        loadCareGuidePartnerTagsAdmin(
          partnershipId,
          page,
          limit,
          order,
          filter,
          (success, total) => {
            if (success) {
              // loop over all pages to get all events
              const pageCount = Math.ceil(total / limit);
              for (var i = 2; i <= pageCount; i++) {
                dispatch(
                  loadCareGuidePartnerTagsAdmin(partnershipId, i, limit, order)
                );
              }
              cb();
            }
          }
        )
      );
    },
  };
};

const CareGuidePartnerTagInputContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CareGuidePartnerTagInput);

export default CareGuidePartnerTagInputContainer;
